import { Skeleton } from '@mui/material'

import { tableStyles } from '../styles'

const SKELETON_BLOCKS = 4
const SKELETON_LINES = 3
const SKELETON_DATES = 8

// Placeholder in the shape of the loaded table: a few collapsed pond blocks.
export function SkeletonTable() {
  const isMobile = new URLSearchParams(window.location.search).get('isMobile') === 'true'

  return (
    <div style={tableStyles.list(isMobile)}>
      {Array.from({ length: SKELETON_BLOCKS }, (_, block) => (
        <div key={block} style={tableStyles.block(isMobile)}>
          <div style={tableStyles.pondHeader(isMobile)}>
            <Skeleton variant="text" width="4em" />
          </div>
          <div style={{ ...tableStyles.scroller(isMobile), overflowX: 'hidden' }}>
            {Array.from({ length: SKELETON_LINES }, (_, line) => (
              <div key={line} style={tableStyles.line}>
                <div style={tableStyles.labelCell(isMobile, 'transparent')}>
                  <Skeleton variant="text" width="70%" />
                </div>
                {Array.from({ length: SKELETON_DATES }, (_, date) => (
                  <div key={date} style={tableStyles.cell(isMobile, false, false)}>
                    <Skeleton variant="text" width="60%" />
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  )
}
